/* src/routes/blog/10Print.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import Gallery from "../../../_components/Gallery.svelte.js";
import PostTop from "../../../_components/Post-Top.svelte.js";
import PostContents from "../../../_components/Post-Contents.svelte.js";
import PostSection from "../../../_components/Post-Section.svelte.js";
import Callout from "../../../_components/Callout.svelte.js";
import LinkExternal from "../../../_components/Link-External.svelte.js";
import P5Canvas from "../../../_components/P5Canvas.svelte.js";
import FullScreen from "../../../_components/Full-Screen.svelte.js";
import sketch from "./10print-js.js";

function create_default_slot_3(ctx) {
	let t;

	return {
		c() {
			t = text("10Print");
		},
		l(nodes) {
			t = claim_text(nodes, "10Print");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (30:4) <FullScreen>
function create_default_slot_2(ctx) {
	let p5canvas;
	let current;
	p5canvas = new P5Canvas({ props: { sketch } });

	return {
		c() {
			create_component(p5canvas.$$.fragment);
		},
		l(nodes) {
			claim_component(p5canvas.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(p5canvas, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(p5canvas.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(p5canvas.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(p5canvas, detaching);
		}
	};
}

// (21:2) <PostSection>
function create_default_slot_1(ctx) {
	let t0;
	let linkexternal;
	let t1;
	let p0;
	let t2;
	let t3;
	let fullscreen;
	let t4;
	let p1;
	let t5;
	let current;

	linkexternal = new LinkExternal({
			props: {
				href: "https://10print.org/",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	fullscreen = new FullScreen({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t0 = text("Simple\n    ");
			create_component(linkexternal.$$.fragment);
			t1 = text("\n    implementation in p5.\n    ");
			p0 = element("p");
			t2 = text("Considering it only uses 2 characters ('\\' and '/') I find this\n      mesmerizing to watch.");
			t3 = space();
			create_component(fullscreen.$$.fragment);
			t4 = space();
			p1 = element("p");
			t5 = text("This page only exists here so I can put it into full screen mode.");
		},
		l(nodes) {
			t0 = claim_text(nodes, "Simple\n    ");
			claim_component(linkexternal.$$.fragment, nodes);
			t1 = claim_text(nodes, "\n    implementation in p5.\n    ");
			p0 = claim_element(nodes, "P", {});
			var p0_nodes = children(p0);
			t2 = claim_text(p0_nodes, "Considering it only uses 2 characters ('\\' and '/') I find this\n      mesmerizing to watch.");
			p0_nodes.forEach(detach);
			t3 = claim_space(nodes);
			claim_component(fullscreen.$$.fragment, nodes);
			t4 = claim_space(nodes);
			p1 = claim_element(nodes, "P", {});
			var p1_nodes = children(p1);
			t5 = claim_text(p1_nodes, "This page only exists here so I can put it into full screen mode.");
			p1_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			mount_component(linkexternal, target, anchor);
			insert(target, t1, anchor);
			insert(target, p0, anchor);
			append(p0, t2);
			insert(target, t3, anchor);
			mount_component(fullscreen, target, anchor);
			insert(target, t4, anchor);
			insert(target, p1, anchor);
			append(p1, t5);
			current = true;
		},
		p(ctx, dirty) {
			const linkexternal_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal_changes.$$scope = { dirty, ctx };
			}

			linkexternal.$set(linkexternal_changes);
			const fullscreen_changes = {};

			if (dirty & /*$$scope*/ 4) {
				fullscreen_changes.$$scope = { dirty, ctx };
			}

			fullscreen.$set(fullscreen_changes);
		},
		i(local) {
			if (current) return;
			transition_in(linkexternal.$$.fragment, local);
			transition_in(fullscreen.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(linkexternal.$$.fragment, local);
			transition_out(fullscreen.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			destroy_component(linkexternal, detaching);
			if (detaching) detach(t1);
			if (detaching) detach(p0);
			if (detaching) detach(t3);
			destroy_component(fullscreen, detaching);
			if (detaching) detach(t4);
			if (detaching) detach(p1);
		}
	};
}

// (20:0) <PostContents>
function create_default_slot(ctx) {
	let postsection;
	let current;

	postsection = new PostSection({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(postsection.$$.fragment);
		},
		l(nodes) {
			claim_component(postsection.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(postsection, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const postsection_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postsection_changes.$$scope = { dirty, ctx };
			}

			postsection.$set(postsection_changes);
		},
		i(local) {
			if (current) return;
			transition_in(postsection.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(postsection.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(postsection, detaching);
		}
	};
}

function create_fragment(ctx) {
	let posttop;
	let t;
	let postcontents;
	let current;

	posttop = new PostTop({
			props: {
				title,
				tags: /*tags*/ ctx[0],
				projects: /*projects*/ ctx[1]
			}
		});

	postcontents = new PostContents({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(posttop.$$.fragment);
			t = space();
			create_component(postcontents.$$.fragment);
		},
		l(nodes) {
			claim_component(posttop.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postcontents.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(posttop, target, anchor);
			insert(target, t, anchor);
			mount_component(postcontents, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postcontents_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postcontents_changes.$$scope = { dirty, ctx };
			}

			postcontents.$set(postcontents_changes);
		},
		i(local) {
			if (current) return;
			transition_in(posttop.$$.fragment, local);
			transition_in(postcontents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(posttop.$$.fragment, local);
			transition_out(postcontents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(posttop, detaching);
			if (detaching) detach(t);
			destroy_component(postcontents, detaching);
		}
	};
}

const title = "10Print";
const date = "2020-06-05";

function instance($$self) {
	const tags = ["p5"];
	const projects = [];
	return [tags, projects];
}

class _10Print extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default _10Print;
//# sourceMappingURL=10Print.svelte.js.map
